import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  ProcessReceivingBarcodeResponse,
  ReceivingDownloadResponse,
  ReceivingUIResponse,
} from "../../models/ApiResponse";
import agent from "../../api/agent";
import { ReceivingResponse } from "../../models/responseModels/receivingResponse";
import { ProcessBarcodeRequest } from "../../models/requestModels/processBarcode";

type InitialState = {
  isLoading: boolean;
  receivingList: ReceivingResponse[];
  errorMessage: string | null;
};

const initialState: InitialState = {
  isLoading: false,
  receivingList: [],
  errorMessage: null,
};

export const getReceivingList = createAsyncThunk<ReceivingUIResponse>(
  "receiving/receivingResponse",
  async () => {
    const response = await agent.ReceivingAgent.getReceivingList();
    return response;
  }
);

export const downloadReceivingDataToCsv = createAsyncThunk<
  ReceivingDownloadResponse,
  ReceivingResponse[]
>("receiving/downloadCsv", async (receivingsData: ReceivingResponse[]) => {
  const response = await agent.ReceivingAgent.receivingCsvDownload(
    receivingsData
  );
  return response;
});

export const downloadReceivingDataToXlsx = createAsyncThunk<
  Blob,
  ReceivingResponse[]
>("receiving/downloadXlsx", async (receivingsData: ReceivingResponse[]) => {
  const response = await agent.ReceivingAgent.receivingXlsxDownload(
    receivingsData
  );
  return response;
});

export const processBarcodeForReceiving = createAsyncThunk<
  ProcessReceivingBarcodeResponse,
  ProcessBarcodeRequest
>(
  "receiving/processBarcode",
  async (processBarcodeRequest: ProcessBarcodeRequest) => {
    const response = await agent.ReceivingAgent.processBarcodeForReceiving(
      processBarcodeRequest
    );
    return response;
  }
);

const receivingSlice = createSlice({
  name: "receiving",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReceivingList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReceivingList.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.isSuccess) {
          state.receivingList = action.payload.data;
        } else {
          state.receivingList = [];
        }
      })
      .addCase(getReceivingList.rejected, (state, action) => {
        state.isLoading = false;
        state.receivingList = [];
        state.errorMessage = action.error.message!;
      })
      .addCase(downloadReceivingDataToCsv.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(downloadReceivingDataToCsv.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(downloadReceivingDataToCsv.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message!;
      })
      .addCase(downloadReceivingDataToXlsx.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(downloadReceivingDataToXlsx.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(downloadReceivingDataToXlsx.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message!;
      });
  },
});

export default receivingSlice.reducer;
